var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6239 6.08932C13.6236 6.089 13.6233 6.08868 13.623 6.08836L7.9115 0.377686C7.66805 0.134155 7.34438 0 7.00009 0C6.6558 0 6.33213 0.134048 6.08857 0.377579L0.380089 6.08537C0.378166 6.0873 0.376243 6.08932 0.37432 6.09125C-0.125609 6.59401 -0.124754 7.40973 0.376777 7.91121C0.605911 8.14043 0.908539 8.27319 1.2321 8.28708C1.24524 8.28836 1.25849 8.289 1.27184 8.289H1.49948V12.4917C1.49948 13.3233 2.1762 14 3.00813 14H5.24264C5.46911 14 5.65284 13.8164 5.65284 13.5898V10.2949C5.65284 9.91542 5.96156 9.60674 6.3411 9.60674H7.65907C8.03861 9.60674 8.34733 9.91542 8.34733 10.2949V13.5898C8.34733 13.8164 8.53096 14 8.75753 14H10.992C11.824 14 12.5007 13.3233 12.5007 12.4917V8.289H12.7118C13.056 8.289 13.3796 8.15495 13.6233 7.91142C14.1254 7.40909 14.1256 6.59198 13.6239 6.08932Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fd08d3d4052e042171c5baf4c3309b4c.svg";
export { ForwardRef as ReactComponent };